import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { asyncApiCall } from '../../api';
import { getFinalizedVouchersApi } from '../apiOuigoRefunds';
import { mapFinalizedVouchersResponse } from '../mappers';
import { VOUCHERS_PAGE_SIZE, createEmptyPagination } from '../utils';

const loadFinalizedVouchersRequest = (parameters) =>
	asyncApiCall(getFinalizedVouchersApi, parameters);

const useArchivedVouchers = ({
	appliedFromDate,
	appliedToDate,
	currentPage,
	enabled,
	intl,
	loadFinalizedVouchers = loadFinalizedVouchersRequest,
	sortBy,
}) => {
	const [vouchers, setVouchers] = useState([]);
	const [pagination, setPagination] = useState(createEmptyPagination);
	const [isLoading, setIsLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [filter, setFilter] = useState(null);

	const loadVouchers = useCallback(async () => {
		if (!enabled) {
			return;
		}

		setIsLoading(true);
		setHasError(false);

		try {
			const response = await loadFinalizedVouchers({
				startDate: appliedFromDate
					? format(appliedFromDate, 'yyyy-MM-dd')
					: undefined,
				endDate: appliedToDate
					? format(appliedToDate, 'yyyy-MM-dd')
					: undefined,
				page: currentPage + 1,
				pageSize: VOUCHERS_PAGE_SIZE,
				sortBy,
			});
			const mappedResponse = mapFinalizedVouchersResponse(response, intl);

			setVouchers(mappedResponse.vouchers);
			setPagination(mappedResponse.pagination);
			setFilter(response?.filter || null);
		} catch {
			setVouchers([]);
			setPagination(createEmptyPagination());
			setHasError(true);
		} finally {
			setIsLoading(false);
		}
	}, [
		appliedFromDate,
		appliedToDate,
		currentPage,
		enabled,
		intl,
		loadFinalizedVouchers,
		sortBy,
	]);

	useEffect(() => {
		loadVouchers();
	}, [loadVouchers]);

	return {
		filter,
		hasError,
		isLoading,
		pagination,
		vouchers,
	};
};

export default useArchivedVouchers;
